import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../_material/material.module';
import { SharedModule } from '../_shared/shared.module';
import { LoginDialogComponent } from './components/login-dialog/login-dialog.component';
import { LoginComponent } from './components/screens/login/login.component';
import { SignupComponent } from './components/screens/signup/signup.component';
import { ForgotPasswordComponent } from './components/screens/forgot-password/forgot-password.component';
import { SplitContainerComponent } from './components/split-container/split-container.component';
import { LoginDialogImageComponent } from './components/login-dialog-image/login-dialog-image.component';
import { LoginImageComponent } from './components/login-dialog-image/images/login-image/login-image.component';
import { SignupImageComponent } from './components/login-dialog-image/images/signup-image/signup-image.component';
import { SignupCodeImageComponent } from './components/login-dialog-image/images/signup-code-image/signup-code-image.component';
import { ForgotPasswordImageComponent } from './components/login-dialog-image/images/forgot-password-image/forgot-password-image.component';
import { TranslateModule } from '@ngx-translate/core';
import { SignupCodeComponent } from './components/screens/signup-code/signup-code.component';
import { RecaptchaModule } from 'ng-recaptcha';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { GuestComponent } from './components/screens/guest/guest.component';
import { FirstLoginComponent } from './components/screens/first-login/first-login.component';
import { FirstLoginImageComponent } from './components/login-dialog-image/images/first-login-image/first-login-image.component';

@NgModule({
  declarations: [
    LoginDialogComponent,
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    SplitContainerComponent,
    LoginImageComponent,
    SignupImageComponent,
    SignupCodeImageComponent,
    ForgotPasswordImageComponent,
    LoginDialogImageComponent,
    SignupCodeComponent,
    GuestComponent,
    FirstLoginComponent,
    FirstLoginImageComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    TranslateModule,
    RecaptchaModule,
    ReactiveFormsModule,
    FormlyModule,
  ],
})
export class LoginModule {}
